/* Ported from ui_kits/storefront/faq.js for the Shopify theme. */
(function () {
  const $ = (s) => document.querySelector(s);
  const input = $('#fqSearch'), clear = $('#fqClear'), count = $('#fqCount'), empty = $('#fqEmpty');
  const groups = [...document.querySelectorAll('.fq-g')];
  const norm = (t) => t.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  function run() {
    const q = norm(input.value.trim()); let hits = 0;
    clear.hidden = !q;
    groups.forEach((g) => {
      let gh = 0;
      g.querySelectorAll('details.qa').forEach((d) => {
        const m = !q || norm(d.textContent).includes(q);
        d.hidden = !m; if (m) gh++;
        if (q && m) d.open = true; else if (!q) d.open = false;
      });
      g.hidden = gh === 0; hits += gh;
    });
    empty.hidden = hits > 0;
    count.textContent = q ? (hits ? hits + (hits === 1 ? ' answer' : ' answers') + ' found' : '') : '';
  }
  input.addEventListener('input', run);
  clear.onclick = () => { input.value = ''; run(); input.focus(); };
  if (location.hash && location.hash.startsWith('#q-')) { const t = document.querySelector(location.hash); if (t) t.open = true; }
  const links = [...document.querySelectorAll('.fq-nav a')];
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) links.forEach((l) => l.classList.toggle('on', l.getAttribute('href') === '#' + en.target.id)); }), { rootMargin: '-30% 0px -60% 0px' });
    groups.forEach((g) => io.observe(g));
  }
  if (window.lucide) lucide.createIcons();
})();
